import Taskify from "../../assets/taskify.jpeg";
import Phonie from "../../assets/phonie.png";
import Urekka from "../../assets/urekka.png";
import Travel from "../../assets/travel.png";
import Github from "../../assets/github.png";
import burtech from "../../assets/burtech.png";
import cliqueng from "../../assets/cliqueng.png";
import dcfoods from "../../assets/dcfoods.png";
import tantaa from "../../assets/tantaa.png";

export const data = [
  {
    id: 1,
    title: "DCFOOD: Foodstuff Ecommerce Website",
    img: dcfoods,
    demo: "https://dcfoodbank.com",
  },
  {
    id: 2,
    title: "CLIQUE: School Learning Management System",
    img: cliqueng,
    demo: "https://clique.ng",
  },
  {
    id: 3,
    title: "TANTA: Software Development Company",
    img: tantaa,
    demo: "https://tantainnovatives.com",
  },
  {
    id: 4,
    title: "BURTECH: An Indigenous Manufacturing Company",
    img: burtech,
    demo: "https://www.burtechindustries.com",
  },
  {
    id: 5,
    title: "PHONIE: Network Carrier Checker",
    img: Phonie,
    demo: "https://super-circle-phoenie.super-circle.repl.co",
  },

  {
    id: 6,
    title: "GITFIND: Github User Finder",
    img: Github,
    demo: "https://githubpersonfinder.netlify.app",
  },
  {
    id: 7,
    title: "TASKIFY: Task Manager App",
    img: Taskify,
    demo: "https://taskify4u.vercel.app/",
  },

  {
    id: 8,
    title: "UREKKA: An EduConsulting Landing Page",
    img: Urekka,
    demo: "https://urekka.vercel.app",
  },
  {
    id: 9,
    title: "POINT-X: Holiday Destinations Planner",
    img: Travel,
    demo: "https://travel-app-lake.vercel.app",
  },
];
